<div class="root">
  <div class="title-container">
    <span class="title">{{ title }}</span>
  </div>

  <ng-container *ngFor="let item of items; let i = index">
    <div class="item" [class.bottom-border]="!isLastItem(items, i)" [routerLink]="[item.url]" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
      <span class="item-label">{{ item.label }}</span>

      <div class="icon">
        <app-lucide-icon [iconName]="'chevron-right'"></app-lucide-icon>
      </div>
    </div>
  </ng-container>
</div>
